// libraries.
import { error } from "@habitech/shared";
import { toast } from "react-toastify";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { useEffect, useState } from "react";

// services.
import { useUserLeadDetail } from "@shared/hooks/userLeadDetail.hook";
import { useAddBonusInfoMutation } from "@store/apiSlices/bonus/services/addBonusInfo.endpoints";

// types.
import { IconTrash } from "@assets";
import { BonusOpType } from "./BonusCard";
import { BonusInfoItem } from "@store/apiSlices/bonus/interfaces/interfaces";

export const DeleteBonus = ({
  bonusInfo,
  onClose,
}: {
  bonusInfo: BonusInfoItem;
  onClose: () => void;
}) => {
  const { nid, email, country } = useUserLeadDetail();
  const [addBonusInfo, { isLoading, isSuccess, isError }] =
    useAddBonusInfoMutation();

  const [showConfirm, setShowConfirm] = useState(false);

  const handleDeleteBonus = () => {
    addBonusInfo({
      amount: bonusInfo.amount ?? 0,
      country: country ?? "",
      meta: { comentario: bonusInfo.meta.comentario },
      nid: Number(nid),
      op_type: BonusOpType.DELETE,
      percentage: bonusInfo.percentage,
      user_id: email,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      toast.success("Se eliminará en las próximas 48 horas");
      setShowConfirm(false);
      onClose();
    }
    if (isError) {
      toast.error("Error al eliminar bono");
    }
  }, [isSuccess, isError]);

  return (
    <OverlayTrigger
      trigger="click"
      placement="top"
      rootClose
      show={showConfirm}
      onToggle={(nextShow) => setShowConfirm(nextShow)}
      overlay={
        <Popover id="popover-delete-bonus">
          <Popover.Header as="h3" className="px-2 py-1">
            Confirmación
          </Popover.Header>
          <Popover.Body>
            <div className="mb-2">¿Deseas eliminar el bono?</div>
            <div className="d-flex gap-2">
              <Button
                className="fw-bold btn-secundary-habi rounded-2 py-2 px-4 w-100"
                onClick={() => setShowConfirm(false)}
              >
                Cancelar
              </Button>
              <Button
                className="btn-habi rounded-2 fw-bold py-2 px-4 w-100"
                onClick={handleDeleteBonus}
                disabled={isLoading}
              >
                {isLoading ? "Eliminando..." : "Eliminar"}
              </Button>
            </div>
          </Popover.Body>
        </Popover>
      }
    >
      <div
        role="button"
        style={{
          cursor: isLoading ? "not-allowed" : "pointer",
        }}
        title="Eliminar bono"
      >
        <IconTrash fill={error} />
      </div>
    </OverlayTrigger>
  );
};
